"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _FiatWithdrawModalComponent = _interopRequireDefault(require("./FiatWithdrawModalComponent"));
var _modalDecorator = _interopRequireDefault(require("../../../../hocs/modalDecorator"));
var _modalActions = require("../../../../redux/actions/modalActions");
var _withdrawActions = require("../../../../redux/actions/withdrawActions");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var mapStateToProps = function mapStateToProps(state) {
  return {
    products: state.apexCore.product
  };
};
var mapDispatchToProps = {
  submitWithdraw: _withdrawActions.createWithdrawTicket
};
var container = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_FiatWithdrawModalComponent["default"]);
var _default = exports["default"] = (0, _modalDecorator["default"])({
  name: _modalActions.MODAL_TYPES.CONFIRM_FIAT_WITHDRAW
})(container);